import Header from "../layout/Header/Header";
import axios from "./custom_axios";
import Cookies from 'js-cookie';
import { publicIpv4 } from "public-ip";
const API_URL = process.env.REACT_APP_API_URL;
const token = Cookies.get("Token");

const loginAPI = async (email, password) => {
    const ipAddress = await publicIpv4();
    console.log("ipAddress", ipAddress)
    const response = await axios.post(`${API_URL}/api/login`, {
        email,
        password,
        ip_address: ipAddress,
    });

    if (response?.data?.token) {
        Cookies.set("Token", response.data.token);
    }

    return response;

};


// const loginAPI = async (email, password) => {
// const response = await axios.post(`/api/login`, { email, password });
// // // //     // try {
// // // //     //     // Nếu không có giá trị forwardedFor, sẽ sử dụng giá trị mặc định
// // // //     //     const headers = {
// // // //     //         'Content-Type': 'application/json',
// // // //     //         'X-Forwarded-For': forwardedFor,  // Nếu không có forwardedFor thì dùng IP mặc định
// // // //     //     };

// // // //     //     const response = await axios.post(
// // // //     //         `${API_URL}/api/login`,
// // // //     //         { email, password },
// // // //     //         { headers }  // Truyền header vào yêu cầu
// // // //     //     );
//         if (response?.data?.token) {
// // // //             // Cookies.set("Token", response.data.token, { expires: 7, path: "/" });
// // // //             // Cookies.set("UserName", response.data.name, { expires: 7, path: "/" });
// // // //             // Cookies.set("Email", response.data.email, { expires: 7, path: "/" });
//         }
//         return response;
// // //     // }
// // //     // catch (error) {
// // //     //     console.error('Error during login:', error);
// // //     //     throw error;
// // //     // }

// };


const register = async (name, phone, email, password, password_confirmation, utm_source) => {
    const ipAddress = await publicIpv4();

    return axios.post(`${API_URL}/api/register`, { name, phone, email, password, password_confirmation, ip_address: ipAddress, utm_source })
}

const forgetpassword = async (email) => {
    return axios.post(`${API_URL}/api/forgot-password`, { email })
}

const getProfile = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/v1/profile`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            }
        );
        return response?.data;
    } catch (error) {
        return { message: "No data" }
    }

}

const updateProfile = async (data) => {
    const token = Cookies.get("Token");

    try {
        const response = await axios.put(`${API_URL}/api/user/update`,
            data,
            {
                headers:
                {
                    'Authorization': `Bearer ${token}`,

                }
            });
        return response?.data;

    } catch (error) {
        return { message: "No data" }
    }
}

// Interceptor để ghi lại thông tin yêu cầu
axios.interceptors.request.use(request => {
    return request;
});

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response && error.response.status === 401) {
    }
    return Promise.reject(error);
});

const getDevice = async () => {
    const token = Cookies.get("Token");
    try {
        const response = await axios.get(`${API_URL}/api/v1/acount/device`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            }
        );
        return response?.data;
    } catch (error) {
        return { message: "No data" }
    }
}
const VerifyAccount = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/v1/profile`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            }
        );
        return response?.data;
    } catch (error) {
        return { message: "No data" }
    }

}
const CheckToken = async (token) => {
    try {
        const response = await axios.post(`${API_URL}/api/checktoken`, // Đổi endpoint thành /api/checktoken
            {
                token: token // Truyền token vào body của request
            },
            {
                headers: {
                    'Content-Type': 'application/json', // Đảm bảo đúng định dạng JSON
                },
            }
        );
        return response?.data; // Trả về dữ liệu từ API
    } catch (error) {
        console.error('Lỗi kiểm tra token:', error.response?.data || error.message);
        return { status: 'error', message: "Token không hợp lệ hoặc đã hết hạn." }; // Xử lý lỗi trả về
    }
}


// export { loginAPI, register, forgetpassword, getProfile, updateProfile, getDevice, VerifyAccount, CheckToken }
export { loginAPI, register, forgetpassword, getProfile, updateProfile, getDevice, VerifyAccount, CheckToken }
